/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Header_ContactInputs */

const zh_landing_header_contact = /** @type {(inputs: Landing_Header_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const en_landing_header_contact = /** @type {(inputs: Landing_Header_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us`)
};

const es_landing_header_contact = /** @type {(inputs: Landing_Header_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

/**
* | output |
* | --- |
* | "Contact us" |
*
* @param {Landing_Header_ContactInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_header_contact = /** @type {((inputs?: Landing_Header_ContactInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Header_ContactInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_header_contact(inputs)
	if (locale === "en") return en_landing_header_contact(inputs)
	return es_landing_header_contact(inputs)
});